import React, { useState, useEffect } from "react";

import { connect } from "react-redux";

import { TRAFFIC_REPORTS_METHOD, TRAFFIC_REPORTS_SMS_METHOD, FAILED_MDR_REPORTS_METHOD } from "const/apiMethods";
import { servicePick, toEndDayTime, toStartDayTime, removeTZFromDate, compareObjects } from "utils";
import { DESC_SORT, TRAFFIC_ADMIN_PATHNAME } from "const";
import { LOCAL_STORAGE_TRAFFIC_STAT_FILTERS } from "const/localStorageKeys";
import { usePrevious } from "hooks";
import PanelLayout from "components/base/PanelLayout";
import PageHeader from "components/base/PageHeader";
import ExportCsv from "components/ExportCsv";
import TrafficReportsFilters from "pages/TrafficReports/TrafficReportsFilters";
import TrafficReportsTable from "pages/TrafficReports/TrafficReportsTable";


import { FlexboxGrid } from "rsuite";

const TrafficReportsPage = ({ service, globalSettings, ...props }) => {
    const currentPathName = props.location.pathname;
    const isFailedMdr = !currentPathName.split("-").find((path) => path === TRAFFIC_ADMIN_PATHNAME);
    const prevIsFailedMdr = usePrevious(isFailedMdr);

    const today = new Date(Date.now());

    let savedFilters = null;
    const defaultFilter = {
        range: [toStartDayTime(today), toEndDayTime(today)],
        group_checkbox: [],
        show_reliable: true,
        show_not_reliable: true,
        ...(!service ? { only_my_account: true } : {})
    };
    const storagedFilters = localStorage.getItem(LOCAL_STORAGE_TRAFFIC_STAT_FILTERS);

    if (storagedFilters && storagedFilters !== "") {
        const {
            dialer_id: dialerId,
            supplier_id: supplierId,
            start_end_date: startEndDate,
            ...parsedFilters
        } = JSON.parse(storagedFilters);
        savedFilters = {
            ...defaultFilter,
            ...parsedFilters,
            supplier_id_list: supplierId ? [supplierId] : [],
            dialer_id_list: dialerId ? [dialerId] : [],
            range: [
                new Date(startEndDate[0]),
                new Date(startEndDate[1]),
            ]
        };

        localStorage.removeItem(LOCAL_STORAGE_TRAFFIC_STAT_FILTERS);
    }

    const defaultSortColumn = "count";
    const defaultSort = { column: defaultSortColumn, type: "desc" };
    const [sort, setSort] = useState(defaultSort);

    const [filters, setFilters] = useState(
        savedFilters
            ? savedFilters
            : defaultFilter
    );
    const [preFilters, setPreFilters] = useState(
        savedFilters
            ? savedFilters
            : defaultFilter
    );

    useEffect(() => {
        if (prevIsFailedMdr !== isFailedMdr) {
            localStorage.removeItem(LOCAL_STORAGE_TRAFFIC_STAT_FILTERS);
            setFilters(defaultFilter);
            setSort(defaultSort);
        }
    }, [isFailedMdr]);

    const methodExport = isFailedMdr
        ? FAILED_MDR_REPORTS_METHOD
        : servicePick(service, TRAFFIC_REPORTS_METHOD, TRAFFIC_REPORTS_SMS_METHOD);

    const exportFilter = { ...preFilters };

    if (exportFilter.range && exportFilter.range.length) {
        exportFilter["start_date"] = removeTZFromDate(toStartDayTime(exportFilter.range[0]));
        exportFilter["end_date"] = removeTZFromDate(toEndDayTime(exportFilter.range[1]));

        delete exportFilter.range;
    }

    const exportGroupCheckbox = exportFilter?.group_checkbox || [];

    if (exportGroupCheckbox.length) {
        delete exportFilter.group_checkbox;
    }

    return (
        <PanelLayout>
            {isFailedMdr
                ? <PageHeader title="Failed MDR Report" showService={false}>
                    <ExportCsv
                        method={methodExport}
                        params={{
                            filter: exportFilter,
                            group_checkbox: exportGroupCheckbox,
                            sort1: sort?.column,
                            sort1_desc: sort?.type === DESC_SORT
                        }}
                        title="Export CSV"
                        fileName="failed_traffic_report.csv"
                        style={{ position: "relative", right: 15 }}
                    />
                </PageHeader>
                : <PageHeader title={`${service ? "Traffic" : "MDR"} Report`} showService={false}>
                    <ExportCsv
                        method={methodExport}
                        params={{
                            filter: exportFilter,
                            group_checkbox: exportGroupCheckbox,
                            sort1: sort?.column,
                            sort1_desc: sort?.type === DESC_SORT
                        }}
                        title="Export CSV"
                        fileName="traffic_report.csv"
                        style={{ position: "relative", right: 15 }}
                    />
                </PageHeader>
            }
            <FlexboxGrid >
                <FlexboxGrid.Item colspan={24}>
                    <TrafficReportsFilters
                        onApplyFilters={(filters) => {
                            setFilters(filters);

                            if (
                                !compareObjects(sort, defaultSort) &&
                                (!!filters.group_checkbox?.length &&
                                    !filters.group_checkbox.includes(sort.column) ||
                                    !filters.group_checkbox?.length)
                            ) {
                                setSort(defaultSort);
                            }
                        }}
                        preFilters={preFilters}
                        setPreFilters={setPreFilters}
                        currentFilters={filters}
                        defaultFilters={defaultFilter}
                        isFailedMdr={isFailedMdr}
                        globalSettings={globalSettings}
                        sort={sort}
                        defaultSort={defaultSort}
                        setSort={setSort}
                    />
                </FlexboxGrid.Item>
            </FlexboxGrid>
            <TrafficReportsTable
                sort={sort}
                filters={filters}
                isFailedMdr={isFailedMdr}
                setSort={setSort}
            />
        </PanelLayout>
    );
};

const mapState = ({ auth, references }) => ({
    service: auth.service,
    globalSettings: references.global_setting,
});

export default connect(mapState)(TrafficReportsPage);
